import { createSlice } from '@reduxjs/toolkit';

let initialState = {
  isAddButtonError: false, // 저장 에러 시 추가버튼 동작
};

const StatusFlagsSlice = createSlice({
  name: 'StatusFlags',
  initialState,
  reducers: {
    setAddButtonError(state, action) {
      state.isAddButtonError = action.payload;
    },
    setAddButtonErrorTrue(state) {
      state.isAddButtonError = true;
    },
    resetAddButtonError(state) {
      state.isAddButtonError = false;
    },
  },
});

export const { setAddButtonError, setAddButtonErrorTrue, resetAddButtonError } =
  StatusFlagsSlice.actions;
export default StatusFlagsSlice.reducer;
